import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { SugarCentrifugue } from "./modelSugarCentrifugue";

class ControllerSugarCentrifugue extends ControllerModel {
    constructor() {
        super("ControllerSugarCentrifugue");

        this.setNewNode = (callback) => {
            let sugarCentrifugue = new SugarCentrifugue();
            sugarCentrifugue.decorate(callback);

            this.addNode(sugarCentrifugue);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let sugarCentrifugue = new SugarCentrifugue();
            sugarCentrifugue.copyFrom(node);
            sugarCentrifugue.decorate(callback);
            this.addNode(sugarCentrifugue)
        }

        this.getProperties = async (node) => {
            let n = new SugarCentrifugue();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new SugarCentrifugue();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerSugarCentrifugue };